import {CoreAsset, SliderOption} from './types';

// Response from the /api/core-cc/assets endpoint
// Hardcoded to make the FAAF less BE dependent
export const CORE_ASSETS: CoreAsset[] = [
  {
    id: 1,
    slug: 'cash',
    name: 'Cash',
    description: 'Checking and savings accounts',
    entity: 'AssetType',
  },
  {
    id: 2,
    slug: 'real_estate',
    name: 'Real estate',
    description: 'Real estate including primary and rental',
    entity: 'AssetType',
  },
  {
    id: 3,
    slug: 'investment_account',
    name: 'Investment Accounts',
    description: 'Stocks, Bonds, Mutual Funds, or Brokerage accounts',
    entity: 'AssetType',
  },
  {
    id: 4,
    slug: 'retirement_account',
    name: 'Retirement Accounts',
    description: '401k, IRA, Roth, etc',
    entity: 'AssetType',
  },
  {
    id: 5,
    slug: 'business',
    name: 'Stock Options',
    description:
      'Employee stock or business interest. ISO, NQSO, RSU, ESOP, etc',
    entity: 'AssetType',
  },
  {
    id: 6,
    slug: 'other',
    name: 'Other',
    description: 'Other assets include art, collectibles, crypto, etc',
    entity: 'AssetType',
  },
];

export const HOUSEHOLD_INCOME_OPTIONS: SliderOption[] = [
  {value: 25000, label: 'Under $50k'},
  {value: 50000, label: '$50k'},
  {value: 75000, label: '$75k'},
  {value: 100000, label: '$100k'},
  {value: 125000, label: '$125k'},
  {value: 150000, label: '$150k'},
  {value: 175000, label: '$175k'},
  {value: 200000, label: '$200k'},
  {value: 225000, label: '$225k'},
  {value: 250000, label: '$250k'},
  {value: 275000, label: '$275k'},
  {value: 300000, label: '$300k'},
  {value: 325000, label: '$325k'},
  {value: 350000, label: '$350k'},
  {value: 375000, label: '$375k'},
  {value: 400000, label: '$400k'},
  {value: 425000, label: '$425k'},
  {value: 450000, label: '$450k'},
  {value: 475000, label: '$475k'},
  {value: 500000, label: '$500k'},
  {value: 525000, label: '$525k'},
  {value: 550000, label: '$550k'},
  {value: 575000, label: '$575k'},
  {value: 600000, label: 'Over $600k'},
];

export const ASSETS_OPTION_VALUES: SliderOption[] = [
  {value: 25000, label: 'Under $25k'},
  {value: 50000, label: '$50k'},
  {value: 75000, label: '$75k'},
  {value: 100000, label: '$100k'},
  {value: 125000, label: '$125k'},
  {value: 150000, label: '$150k'},
  {value: 175000, label: '$175k'},
  {value: 200000, label: '$200k'},
  {value: 250000, label: '$250k'},
  {value: 300000, label: '$300k'},
  {value: 350000, label: '$350k'},
  {value: 400000, label: '$400k'},
  {value: 450000, label: '$450k'},
  {value: 500000, label: '$500k'},
  {value: 550000, label: '$550k'},
  {value: 600000, label: '$600k'},
  {value: 650000, label: '$650k'},
  {value: 700000, label: '$700k'},
  {value: 750000, label: '$750k'},
  {value: 800000, label: '$800k'},
  {value: 850000, label: '$850k'},
  {value: 900000, label: '$900k'},
  {value: 950000, label: '$950k'},
  {value: 1000000, label: '$1M'},
  {value: 1100000, label: '$1.1M'},
  {value: 1200000, label: '$1.2M'},
  {value: 1300000, label: '$1.3M'},
  {value: 1400000, label: '$1.4M'},
  {value: 1500000, label: '$1.5M'},
  {value: 1600000, label: '$1.6M'},
  {value: 1700000, label: '$1.7M'},
  {value: 1800000, label: '$1.8M'},
  {value: 1900000, label: '$1.9M'},
  {value: 2000000, label: '$2M'},
  {value: 2100000, label: '$2.1M'},
  {value: 2200000, label: '$2.2M'},
  {value: 2300000, label: '$2.3M'},
  {value: 2400000, label: '$2.4M'},
  {value: 2500000, label: '$2.5M'},
  {value: 2600000, label: '$2.6M'},
  {value: 2700000, label: '$2.7M'},
  {value: 2800000, label: '$2.8M'},
  {value: 2900000, label: '$2.9M'},
  {value: 3000000, label: '$3M'},
  {value: 3250000, label: '$3.25M'},
  {value: 3500000, label: '$3.5M'},
  {value: 3750000, label: '$3.75M'},
  {value: 4000000, label: '$4M'},
  {value: 4250000, label: '$4.25M'},
  {value: 4500000, label: '$4.5M'},
  {value: 4750000, label: '$4.75M'},
  {value: 5000000, label: 'Over $5M'},
];

export const iconByAssetID: Record<
  number,
  {src: string; width: number; height: number; fontAwesomeIcon?: string}
> = {
  1: {
    src: '/static/svg/flat/icon_money_cash.svg',
    width: 20,
    height: 20,
    fontAwesomeIcon: 'fa-light fa-money-bill-wave',
  },
  2: {
    src: '/static/svg/flat/icon_bank.svg',
    width: 20,
    height: 20,
    fontAwesomeIcon: 'fa-light fa-building',
  },
  3: {
    src: '/static/svg/flat/icon_graph_arrow.svg',
    width: 20,
    height: 17,
    fontAwesomeIcon: 'fa-light fa-chart-line',
  },
  4: {
    src: '/static/svg/flat/icon_umbrella.svg',
    width: 20,
    height: 16,
    fontAwesomeIcon: 'fa-light fa-umbrella',
  },
  5: {
    src: '/static/svg/flat/icon_briefcase.svg',
    width: 20,
    height: 19,
    fontAwesomeIcon: 'fa-light fa-briefcase',
  },
  6: {
    src: '/static/svg/flat/icon_coin.svg',
    width: 20,
    height: 20,
    fontAwesomeIcon: 'fa-light fa-coins',
  },
};

export const AFFILIATES_IMAGES: Record<string, string> = {
  nerdWallet: '/static/img/onboarding/affiliates/nerdwallet.svg',
  usaToday: '/static/img/onboarding/affiliates/usa-today.svg',
  forbes: '/static/img/onboarding/affiliates/forbes-advisor.svg',
  myBankTracker: '/static/img/onboarding/affiliates/mybanktracker.svg',
  cnn: '/static/img/onboarding/affiliates/cnn.svg',
  investopedia: '/static/img/onboarding/affiliates/investopedia.svg',
  moneyTalksNews: '/static/img/onboarding/affiliates/money-talks-news.svg',
  moneyWise: '/static/img/onboarding/affiliates/moneywise.svg',
  usNews: '/static/img/onboarding/affiliates/us-news.svg',
  bankRate: '/static/img/onboarding/affiliates/bankrate.svg',
  money: '/static/img/onboarding/affiliates/money.svg',
  investor: '/static/img/onboarding/affiliates/advisor-search.svg',
  betterbuck: '/static/img/onboarding/affiliates/betterbuck.svg',
  financebuzz: '/static/img/onboarding/affiliates/financebuzz.svg',
  consumervoice: '/static/img/onboarding/affiliates/consumer-voice.svg',
  fortune: '/static/img/onboarding/affiliates/fortune-recommends.svg',
  kiplinger: '/static/img/onboarding/affiliates/kiplinger.svg',
  'yep-ads': '/static/img/onboarding/affiliates/yep-ads.svg',
  joywallet: '/static/img/onboarding/affiliates/joywallet.svg',
  '247wallst': '/static/img/onboarding/affiliates/24-7-wallstreet.svg',
  'prime-women': '/static/img/onboarding/affiliates/prime-women.svg',
  moby: '/static/img/onboarding/affiliates/moby.svg',
  'money-crashers': '/static/img/onboarding/affiliates/money-crashers.svg',
};

export const PATH_TO_AFFILIATES: Record<string, string> = {
  '/forms/nerdwallet': AFFILIATES_IMAGES.nerdWallet,
  '/forms/usa-today': AFFILIATES_IMAGES.usaToday,
  '/forms/forbes-advisor': AFFILIATES_IMAGES.forbes,
  '/forms/mybanktracker': AFFILIATES_IMAGES.myBankTracker,
  '/forms/cnn': AFFILIATES_IMAGES.cnn,
  '/forms/investopedia': AFFILIATES_IMAGES.investopedia,
  '/forms/moneytalksnews': AFFILIATES_IMAGES.moneyTalksNews,
  '/forms/moneywise': AFFILIATES_IMAGES.moneyWise,
  '/forms/money': AFFILIATES_IMAGES.money,
  '/forms/usnews': AFFILIATES_IMAGES.usNews,
  '/forms/bankrate': AFFILIATES_IMAGES.bankRate,
  '/forms/investor': AFFILIATES_IMAGES.investor,
  '/forms/betterbuck': AFFILIATES_IMAGES.betterbuck,
  '/forms/financebuzz': AFFILIATES_IMAGES.financebuzz,
  '/forms/fortune': AFFILIATES_IMAGES.fortune,
  '/forms/kiplinger': AFFILIATES_IMAGES.kiplinger,
  '/forms/kiplinger-1': AFFILIATES_IMAGES.kiplinger,
  '/forms/kiplinger-2': AFFILIATES_IMAGES.kiplinger,
  '/forms/kiplinger-3': AFFILIATES_IMAGES.kiplinger,
  '/forms/yep-ads': AFFILIATES_IMAGES['yep-ads'],
  '/forms/joywallet': AFFILIATES_IMAGES.joywallet,
  '/forms/247wallst': AFFILIATES_IMAGES['247wallst'],
  '/forms/prime-women': AFFILIATES_IMAGES['prime-women'],
  '/forms/moby': AFFILIATES_IMAGES.moby,
  '/forms/money-crashers': AFFILIATES_IMAGES['money-crashers'],
};
